import { useEffect, useRef, useMemo } from "react";
import Fuse from "fuse.js";

const useFuseSearch = <T>(query: string = "", items: T[], keys: string[]) => {
  const fuseRef = useRef<Fuse<T> | null>(null);

  useEffect(() => {
    fuseRef.current = new Fuse(items, {
      location: 0,
      threshold: 0.3,
      distance: 100,
      keys,
    });
  }, [items, keys]);

  const filteredData = useMemo(() => {
    const fuse = fuseRef.current;
    if (!fuse) return items;
    const response = fuse.search(query);
    const _data = response?.map(({ item }) => item) as T[];

    if (query?.length > 0) {
      return _data;
    } else {
      return items;
    }
  }, [items, query]);

  if (!query || query.length === 0) return items;

  return filteredData;
};

export default useFuseSearch;
